import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import floor from 'lodash/floor';
import round from 'lodash/round';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getEndOfToday = () => dayjs.tz(Date.now()).endOf('day');

export const getEndOfBeforeToday = () => dayjs.tz(Date.now()).subtract(1, 'day').endOf('day');

export const convertTimeToHourMinute = (time: number, unit: 's' | 'm'): [number, number] => {
  if (time <= 0) return [0, 0];

  const second = unit === 's' ? time : time * 60;
  const minute = second / 60;
  const hours = floor(minute / 60);
  const restMinute = round(minute % 60);
  return [hours, restMinute];
};

export const convertTimeToHour = (time: number, unit: 's' | 'm'): number => {
  if (time === 0) return 0;
  const second = unit === 's' ? time : time * 60;
  const minute = second / 60;
  const hours = round(minute / 60, 2);
  return hours;
};

export const displayHourMinute = (h: number, m: number) => {
  const hour = String(h).padStart(2, '0');
  const minute = String(m).padStart(2, '0');

  return `${hour}:${minute}`;
};

export const formatTimeToHourMinuteSecond = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0")
  ].join(":");
}

export function isValidDateString(dateString: string): boolean {
  // Regular expression to match datetime format
  const datetimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

  // Check if the string matches the datetime format
  if (datetimeRegex.test(dateString)) {
    return true;
  }

  // Convert to datetime and check if it's valid
  const date = new Date(dateString);
  return !Number.isNaN(date.getTime());
}

export function minutesToHHMM(minutes: number | null | undefined): string{
  if (!minutes || minutes <= 0) return "";

  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

export function hhmmToMinutes (time: string | null | undefined): number {
  if (!time) return 0;

  const [hours, minutes] = time.split(":").map(Number);

  if (!isFinite(hours) || !isFinite(minutes)) return 0;

  return hours * 60 + minutes;
};

/**
 * Returns the current date and time as text, in the app timezone.
 * The app timezone comes from `REACT_APP_TIMEZONE`, not from the browser.
 *
 * @param format A dayjs format string, for example `DATE_TIME_FILE_NAME`.
 * @example
 * formatCurrentDateTime(DATE_TIME_FILE_NAME); // '2026-11-04_160511'
 */
export const formatCurrentDateTime = (format: string) => dayjs.tz(Date.now()).format(format);